import _ from 'lodash'
import $ from 'jquery'
import i18n from 'scoreboard/components/i18n'
import OrgGardener from 'scoreboard/organizations/organizations-gardener'
import OrgTreeSelector from 'scoreboard/organizations/org-multi-tree-selector'
import spotlight from 'scoreboard/components/spotlight'
import projects from 'scoreboard/projects/projects'
import template from './admin-replication.hbs'
import DisplayHeader from 'scoreboard/components/display-header'
import treeSomeAncestors from 'scoreboard/components/tree-some-ancestors'
import layoutManager from 'scoreboard/components/layout-manager'
import scrollContainer from 'scoreboard/components/scroll-container'
import constants from 'scoreboard/components/constants'

const SelectiveRepOrgGardener = OrgGardener.extend({
	_resolveUrlSection: section => '',

	_treeNodeClassName: function(node) {
		node.label = node.label + `  (${i18n.get('common.id')} ${node.id})`
		return node
	}
})


/**
 * Given a tree and id of a node, applies the specified function to all of the node's descendants
 */
function eachDescendant(tree, id, fun) {
	let node = tree[id]
	if (!node) return
	let children = node.children
	if (children && children.length) {
		_.each(children, child => {
			fun(node, child)
			eachDescendant(tree, child.id, fun)
		})
	}
}

let SelectiveReplication = OrgTreeSelector.extend({

	className: 'admin table-hack display-layout admin-replication multi-tree-selector two-column-details-form',

	isDialog: false,

	events: _.extend({}, OrgTreeSelector.prototype.events, {
		'click .cancel': 'cancel',
		'change input[type=checkbox]': 'cascade'
	}),

	row(data) {
		var row = OrgTreeSelector.prototype.row.apply(this, arguments)
		this._sizeOrgPanelHeader()
		// This view doesn't need to use jQuery's scrollIntoView() becuase of the way
		// it's setup. The panels appear side-by-side with scrolling only ocurring within
		// the panels unless we're in a narrower orientation.
		// scrollIntoView() also causes the entire viewport to jump up partially
		// out of view in IE/Edge (see #21431)
		this._newRow.scrollIntoView = () => {}
	},

	_insertTemplate: function(ctx) {
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.orgReplicationSelection'),
			mobileGearHidden: true
		}).render().el, template(ctx))
	},

	createGardener() {
		return new SelectiveRepOrgGardener({
			showProjectSelector: true,
			projectId: this.projectId || projects.id,
			descendants:true,
			ordered:true,
			copyInfo: true,
			streamOptions: {
				error: () => this._initializationError(),
				projectId: this.projectId || projects.id
			},
			finderOptions: {
				type: 'light'
			}
		})
	},

	initialize(options = {}) {
		this._dereplicateById = {}
		this._cascadeById = {}
		this._hiddenById = {}
		this._treeHierarchyByProjectId = {}

		OrgTreeSelector.prototype.initialize.apply(this, arguments)
		this.options.showId = true
		this.options = _.extend(options, {
			treeActions : {
				itemPermissible: (data) => {return _.isNil(data.templateId)}
			}
		})
		this.on('done', (selection) => {
			let data = {}
			_.each(_.keys(this._dereplicateById), (id) => {
				data[id] = {id, cascade: false, replicate: false}
			})
			_.each(selection, (cascade, id) => {
				data[id] = {id, cascade, replicate: true}
			})
			$.post('api/admin/replication/selectedOrganizations', JSON.stringify(_.values(data))).then(() => {
				//restart the form view process
				this.formView.start({ isNew: false })
				this.updatedSelections = data
			})
		})

		this.on('resize', () => this._sizeOrgPanelHeader())

		let pid = null
		let currentCascadedLeft = null
		let currentCascadedRight = null
		// #19527 hide redundant selections from cascading upon initial viewing.  first sort by project/leftbound
		// then mark all children of cascaded nodes as hidden.
		_.each(_.orderBy(this.oldSelections(), ['projectId', 'order']), selection => {
			if (pid != selection.projectId) {
				//we're in a new project, reset cascade bounds
				currentCascadedLeft = null
				currentCascadedRight = null
				pid = selection.projectId
			}

			if (currentCascadedLeft < selection.order && currentCascadedRight > selection.rightBound) {
				this._hiddenById[selection.id] = selection
			} else {
				currentCascadedLeft = null
				currentCascadedRight = null
			}

			if (selection.cascade) {
				this._cascadeById[selection.id] = selection
				//only set the cascade left/right if ancestor is not already cascading
				currentCascadedLeft = currentCascadedLeft || selection.order
				currentCascadedRight = currentCascadedRight || selection.rightBound
			}
		})
	},

	_getTwoColumnDetailsFormOptions: function() {
		return {
			topMarginAdjustment: layoutManager.getAppTopMargin() + constants.STANDARD_MARGIN
		}
	},

	_initializationError() {
		this._onGardenerError()
		this._initializeOrgData()
		this._renderInitialSelections()
	},

	setupStream (stream) {
		OrgTreeSelector.prototype.setupStream.apply(this, arguments)
		stream.once('end', () => {
			//once we have all the data we can figure out how things should be hidden
			this._initializeOrgData()
		})
	},

	_sizeOrgPanelHeader() {
		this.$('.tree-selector-table .panel-header')
			.width(this.$('.tree-selector-table .panel-content').width() - 20) // 20px padding
	},

	_initializeOrgData() {
		this._parseTreeHeirachy()
		this._sizeOrgPanelHeader()
	},

	_parseTreeHeirachy() {
		let treeHierachy = {}
		_.each(this.orgData, node => {
			node.children = []
			treeHierachy[node.id] = node
			if (node.parentId) {
				//note this assumes tree data is already ordered, which it is
				treeHierachy[node.parentId].children.push(node)
				node.parent = treeHierachy[node.parentId]
			}
		})
		this._treeHierarchyByProjectId[this.projectId] = treeHierachy
	},

	oldSelections() {
		return _.cloneDeep(this.options.selections)
	},

	_onGardenerError() {
		OrgTreeSelector.prototype._onGardenerError.apply(this, arguments)
		// If there are selected organizations already, don't show the
		// 'there are no selected organizations' message in the table to the right
		this.$('.none-selected').toggleClass('is-not-displayed', _.isEmpty(this.oldSelections()
			&& _.isEmpty(this.newSelections())))
	},

	transformSelection(result, object) {
		if (!this._hiddenById[object.id] || this._cascadeById[object.id]) {
			result.push(object)
		}
	},

	initItemData (treeItem) {
		return _.defaults({cascade: false}, treeItem)
	},

	selectItem () {
		//if we don't yet know the hierarchy we're not ready to select anything, do nothing
		let treeHierarchy = this._treeHierarchyByProjectId[this.projectId]
		if (treeHierarchy == null) return

		let treeItem = this.gardener.tree.selected()
		let nodeWithCascade
		treeSomeAncestors(treeHierarchy, treeItem.id, parent => {
			nodeWithCascade = this._cascadeById[parent.id]
			return nodeWithCascade
		})
		let row
		if (nodeWithCascade) {
			row = this.$('.table tr[data-id=' + nodeWithCascade.id + ']')
		} else {
			row = OrgTreeSelector.prototype.selectItem.apply(this, arguments)
		}
		// If a new row was selected, make sure it's scrolled into view
		if (row) {
			row = row.length ? row[0] : row
			this._scrollIntoView(row)
			spotlight(row)
		}

		delete this._dereplicateById[treeItem.id]
	},

	spotlightRow() {
		var row = OrgTreeSelector.prototype.spotlightRow.apply(this, arguments)
		// If a row is spotlighted, we need to make sure it's scrolled into view.
		if (row) {
			this._scrollIntoView(row[0])
		}
	},

	_scrollIntoView(row) {
		scrollContainer(this.el)[0].scrollTop = row.offsetTop
	},

	'delete' (e) {
		let row = $(e.currentTarget).closest('tr')
		let id = row.data('id')
		this._dereplicateById[id] = true
		delete this._cascadeById[id]
		OrgTreeSelector.prototype.delete.apply(this, arguments)
		this._sizeOrgPanelHeader()
	},

	cancel (e) {
		this.trigger('cancel', this.updatedSelections || this.oldSelections())
	},

	cascade (e) {
		let cb = $(e.currentTarget)
		let row = cb.closest('tr')
		let id = row.data('id')
		if (cb.prop('checked')) {
			this._cascadeById[id] = this.gardener.tree.get(id)
		} else {
			delete this._cascadeById[id]
		}
	},

	context() {
		return {
			title: i18n.get('admin.orgReplicationSelection'),
			treeIcon: 'browse',
			treeIconClass: 'icon-browse',
			treeLabel: i18n.get('common.organization.organizations'),
			selectedLabel: i18n.get('report.metricComparisonReport.selectedOrganizations'),
			noneSelectedKey: 'admin.group.organizationPermissions.none',
			emptyTreeMessage: i18n.get('common.organization.noOrganizations'),
			cascadeHelpKey: 'admin.group.organizationReplicationSelection.cascade.help',
			submitLabel: i18n.get('common.done')
		}
	},

	_getScrollContainer: function() {
		return this.$('.scroll-container')
	},

	_isDialog: function() {
		return false
	}
})

export default SelectiveReplication

SelectiveReplication.__filename__ = 'admin/configuration/selective-replication.js'
